import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  constructor(private authService: AuthService) {}

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (!route.data || !route.data.preload) return of(null);
    if (route.data.authenticatedOnly && !this.authService.employeeId) return of(null);
    const delay = Number(route.data.preloadDelay) || 0;
    return timer(delay).pipe(mergeMap(() => load()));
  }
}
